import isClient from './isClient';

const isRunningOnDevServer =
  isClient() && window?.location?.hostname === 'consumer.dev.nest.joybird.com';

const isDevServer = () => isRunningOnDevServer;

export default isDevServer;
